import { useConfig } from "../../contexts/ConfigContext"
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import "./style.css"

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ gradeBreakdown, avgScore, avgGrade, gradeScale }) => {

    const { config } = useConfig();
    const gradeOrder = Object.keys(gradeScale);

    const sortedBreakdown = [...gradeBreakdown].sort(
    (a, b) => gradeOrder.indexOf(a.grade) - gradeOrder.indexOf(b.grade)
    );

    const data = {
        labels: sortedBreakdown.map((item) => item.grade),
        datasets: [
            {
                data: sortedBreakdown.map((item) => item.number_of_respondents),
                backgroundColor: gradeOrder.map((grade) => gradeScale[grade].color),
                borderWidth: 1,
            },
        ],
    };

    return (
        <div className="donut-container">
            <Doughnut
            data={data}
            options={{
                cutout: "60%",
                plugins: { legend: { display: false } },
                responsive: true,
                maintainAspectRatio: false
            }}
            className="piechart"
            />
            {avgScore != null && (
            <div
                className="donut-center-label"
                style={{
                color: config.gradeScale[avgGrade].color,
                }}
            >
                {avgScore}
            </div>
            )}
        </div>
    );
};

export default PieChart;
